module.exports = __webpack_public_path__ + "static/img/SAMBA.340f21d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simba/SAMBA.png
// module id = GRxO
// module chunks = 0